export function formatRelativeTime(isoOrDate: string | Date): string {
	const date = typeof isoOrDate === 'string' ? new Date(isoOrDate) : isoOrDate
	if (Number.isNaN(date.getTime())) return ''

	const seconds = Math.floor((Date.now() - date.getTime()) / 1000)
	if (seconds < 60) return 'Just now'
	const minutes = Math.floor(seconds / 60)
	if (minutes < 60) return `${minutes} minute${minutes === 1 ? '' : 's'} ago`
	const hours = Math.floor(minutes / 60)
	if (hours < 24) return `${hours} hour${hours === 1 ? '' : 's'} ago`
	const days = Math.floor(hours / 24)
	if (days === 1) return 'Yesterday'
	if (days < 7) return `${days} days ago`
	return date.toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' })
}

export function formatUtcExpiry(iso: string): string {
	const d = new Date(iso)
	if (Number.isNaN(d.getTime())) return iso
	return `${d.toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' })} at ${d.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit', second: '2-digit', timeZone: 'UTC' })} UTC`
}
